define('modules/Checkout/OnePageCheckout.Extra',[
    'jquery',
    'lodash',
    'global/all'
], function ($, _, Roc) {
        'use strict';

    var lastPromise = null;

    function setupQueue() {
        var queueDeferred = $.Deferred();
        $.when(lastPromise).always(function () {
            queueDeferred.resolve();
        });

        return queueDeferred.promise();
    }

    function addRequestToQueue (method, request) {
        var methodDeferred = $.Deferred();
        var queueDeferred = setupQueue();
        queueDeferred.then(function () {
            methodDeferred = method.apply(this, [request]);
        });
        lastPromise = methodDeferred.promise();
    };

    var selector = '.additional-information';
    var forms = {
        poNumber: {
            Fields: [
                {
                    "Name": 'PO Number',
                    "Field": '#poNumber',
                    "Param": 'purchaseOrder.purchaseOrderNumber',
                    "Type": 'Text',
                    "Optional": true,
                    "Validators": [
                        {
                            "Type": 'MaxLength',
                            "Value": 22
                        }
                    ]
                }
            ],
            Validate: true,
            RequestParam: 'purchaseOrder'
        },
        orderNotes: {
            Fields: [
                {
                    "Name": 'Order Notes',
                    "Field": '#order-notes',
                    "Param": 'orderNotes'
                }
            ],
            Validate: true,
            RequestParam: 'orderNotes',
            RequestParamType: 'SingleValue'
        }
    };

    function executeQueueRequests(method, request) {
        addRequestToQueue(method, request);
    }

    function updateChekoutExtraData() {
        var request = {
            orderId: '{orderId}'
        };
        $.each(forms, function (formName, form) {
            var data = Roc.Forms.getFormValues(form);
            request = $.extend({}, request, data);
        });

        return $.proxyRequest({
            url: 'api/store/cart/extra/update',
            data: JSON.stringify(request),
            type: 'PUT',
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) {
            }
        });
    }

    function updateAdditionalInformationEvt() {
        $(document).on('change', selector, function() {
            executeQueueRequests(updateChekoutExtraData);
        });
    }
     

    function bindEvents() {
        updateAdditionalInformationEvt();
    }

    var OnePageCheckoutExtra = {
        forms: forms,
        bindEvents: bindEvents,
        executeQueueRequests: executeQueueRequests
    };

    Roc.Logger.debug('OnePageCheckout.Extra.js Loaded:', OnePageCheckoutExtra);
    return OnePageCheckoutExtra;
});
